<template >
    <div class="px-8 py-8">
        <div class="text-2xl font-extrabold">
            식단표 앱 데이터 삭제요청
        </div>
        <div>
            귀하의 연락처를 남겨주세요
            <br>
            담당자 확인후 데이터 삭제를 진행합니다
        </div>
        <v-container>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field type="text" v-model="nickname" placeholder="앱네 닉네임을 입력해주세요"
                        class="border-2 border-gray-300 rounded-md p-2 w-full mt-2" />
                </v-col>
                <v-col cols="12" md="4" />
                <v-col cols="12" md="4">
                    <v-text-field type="text" v-model="appName" placeholder="식단표앱 이름을 입력해주세요"
                        class="border-2 border-gray-300 rounded-md p-2 w-full mt-2" />
                </v-col>
                <v-btn v-show="isFinished === false" @click="submit">전송 </v-btn>
            </v-row>
        </v-container>

    </div>
</template>

<script>
import { ApiService } from "@/services/GuneApiService.js";

export default {
    data() {
        return {
            nickname: "",
            appName: "",
            isFinished: false
        };
    },

    methods: {
        submit() {

            if (this.nickname.length < 1) {
                alert("닉네임을 입력해주세요")
                return
            }
            const { nickname, appName } = this;

            if (nickname === "" || appName === "") {
                alert("닉네임과 앱이름을 입력해주세요")
                return
            }


            ApiService().post('/privacy', {
                nickname,
                appName
            }).then((res) => {
                this.isFinished = true;
                this.nickname == "";
                this.appName == "";

                alert("완료되었습니다" + res.data);
            }).catch((err) => {
                alert("오류가 발생했습니다" + err)
            });
        }

    },
};
</script>